import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';
import { UnitInput, UnitInputPosition } from 'views/templates/module/unitInput';
import { InputTemplate, MaskType } from 'views/templates/module/inputTemplate';
import { AddressInput } from 'views/templates/module/addressInput';
import { useRepresentInfo } from './hooks';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { TemplateProps } from '../common';
import { DateInput } from 'views/mutual/dateInput';

export type RepresentInfoProps = {
  formik: any;
  representFirstNameProps: any;
  representLastNameProps: any;
  representFirstNameKanaProps: any;
  representLastNameKanaProps: any;
  representBirthDayProps: any;
  representAddressPorps: any;
  representMobilePhoneNumberProps: any;
  representPositionProps: any;
  representMailAddressPorps: any;
  representConfirmMailAddressPorps: any;
};

export const RepresentInfoWrapper = () => {
  return <RepresentInfo {...useRepresentInfo({ isUpdate: false })} />;
};

export const RepresentInfo = ({
  formik,
  representFirstNameProps,
  representLastNameProps,
  representFirstNameKanaProps,
  representLastNameKanaProps,
  representBirthDayProps,
  representAddressPorps,
  representMobilePhoneNumberProps,
  representPositionProps,
  representMailAddressPorps,
  representConfirmMailAddressPorps,
  isUpdate,
}: RepresentInfoProps & TemplateProps) => {
  const { setAccountOpenProfileDetailsPageType } = useCorporateAccountOpenProfileDetailsPageTypeStore();

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      {!isUpdate && <Caption label="代表者情報" />}
      <div className="accountOpenTemplate_input">
        <FormContentHeader label="代表者氏名" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <UnitInput label="姓" unit={UnitInputPosition.before} placeholder="例：東京" {...representLastNameProps} />
          <UnitInput label="名" unit={UnitInputPosition.before} placeholder="例：太郎" {...representFirstNameProps} />
        </div>

        <FormContentHeader label="代表者氏名（フリガナ）" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <UnitInput
            label="セイ"
            unit={UnitInputPosition.before}
            placeholder="例：トウキョウ"
            {...representLastNameKanaProps}
          />
          <UnitInput
            label="メイ"
            unit={UnitInputPosition.before}
            placeholder="例：タロウ"
            {...representFirstNameKanaProps}
          />
        </div>

        <FormContentHeader label="生年月日" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <DateInput placeholder={'年/月/日'} showYearMonthDropdown={true} {...representBirthDayProps} />
        </div>

        <FormContentHeader label="代表者住所" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <AddressInput name="represent_address" {...representAddressPorps} />
        </div>

        <FormContentHeader label="代表者携帯電話番号" formType={FormType.Required} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="tel"
            placeholder="例：08000000000（ハイフンは不要です）"
            maxLength={11}
            masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
            {...representMobilePhoneNumberProps}
          />
        </div>

        <FormContentHeader label="メールアドレス" formType={FormType.Optional} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="例：example@example.com"
            masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
            {...representMailAddressPorps}
          />
        </div>
        <FormContentHeader label="メールアドレス（確認用）" formType={FormType.Optional} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="例：example@example.com"
            masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
            {...representConfirmMailAddressPorps}
          />
        </div>

        <FormContentHeader label="ご役職" formType={FormType.Optional} />
        <div className="accountOpenTemplate_input_wrapper">
          <InputTemplate type="text" placeholder="例：代表取締役社長" {...representPositionProps} />
        </div>
      </div>
      {!isUpdate && (
        <div className="accountOpenTemplate_button">
          <Button type={ButtonType.Submit} label="次へ" buttonFill={ButtonFill.black} buttonSize={ButtonSize.medium} />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.contactInfo)}
          />
        </div>
      )}
    </form>
  );
};
